// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"df6288ce","453":"305708bf"}[chunkId] + ".chunk.js";
};